
import { DynamicParameter, DynamicParameterValue } from "@/types/insights"
import { Component, Vue, Prop } from "vue-property-decorator"

import ParameterValue from "../Controls/ParameterValue.vue"
import DynamicParameterValueControl from "@/components/Insights/DynamicParameterValue.vue"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"

@Component({
	components: {
		"parameter-value": ParameterValue,
		"dynamic-parameter-value": DynamicParameterValueControl,
		"help-icon": HelpIcon
	}
})
export default class DashboardGlobalParameters extends Vue {
	@Prop({ default: null })
	dashboardInsightParameters!: DynamicParameter[]

	@Prop({ default: () => {} })
	dynamicParameterValues!: { [key: string]: DynamicParameterValue }

	expanded: boolean = true

	private setParameter (key: string, value: DynamicParameterValue | null) {
		this.$emit("setParameter", key, value)
	}
}

